var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYesMicrophone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.93164 7.45104C3.10886 8.66871 3.71856 9.78187 4.64921 10.5869C5.57985 11.3919 6.76921 11.8349 7.99971 11.8349M7.99971 11.8349C9.23021 11.8349 10.4196 11.3919 11.3502 10.5869C12.2809 9.78187 12.8906 8.66871 13.0678 7.45104M7.99971 11.8349V14.3996M8.00044 1.59961C7.41848 1.59961 6.86035 1.83079 6.44885 2.2423C6.03734 2.65381 5.80615 3.21193 5.80615 3.7939V6.71961C5.80615 7.30157 6.03734 7.8597 6.44885 8.2712C6.86035 8.68271 7.41848 8.91389 8.00044 8.91389C8.5824 8.91389 9.14053 8.68271 9.55203 8.2712C9.96354 7.8597 10.1947 7.30157 10.1947 6.71961V3.7939C10.1947 3.21193 9.96354 2.65381 9.55203 2.2423C9.14053 1.83079 8.5824 1.59961 8.00044 1.59961Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYesMicrophone);
export default __webpack_public_path__ + "static/media/yes-microphone.f5030924318a76b36d4439fdc23ea930.svg";
export { ForwardRef as ReactComponent };